export const randFloat = (min: number, max: number): number => Math.random() * (max - min) + min;

export const randInt = (min: number, max: number): number => Math.floor(Math.random() * (max - min + 1)) + min;
